import { render, staticRenderFns } from "./CreateSubDivision.vue?vue&type=template&id=925dc82e&"
import script from "./CreateSubDivision.vue?vue&type=script&lang=js&"
export * from "./CreateSubDivision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports